import {
    computed,
    observable,
    onBecomeObserved,
    onBecomeUnobserved,
} from "mobx";

import {
    IPromiseIntervalHandle,
    setPromiseInterval,
} from "@formant/core/common/setPromiseInterval";
import { duration } from "@formant/core/model/duration";

import { IConnectedStore } from "./IConnectedStore";

export class ConnectedStore implements IConnectedStore {
    @computed
    get isOnline(): boolean {
        return this.hasConnection && this.formantPing;
    }

    @observable
    private hasConnection: boolean = navigator.onLine;

    @observable
    private formantPing: boolean = false;

    private cancelPing: IPromiseIntervalHandle | null = null;

    constructor(private services: string[]) {
        window.addEventListener("offline", () => (this.hasConnection = false));
        window.addEventListener("online", () => (this.hasConnection = true));

        onBecomeObserved(this, "formantPing", () => {
            this.cancelPing = setPromiseInterval({
                func: this.ping,
                delay: duration.minute,
            });
        });

        onBecomeUnobserved(this, "formantPing", () => {
            void this.cancelPing?.stop();
            this.cancelPing = null;
        });
    }

    private ping = async (): Promise<void> => {
        const rnd = Math.floor(Math.random() * this.services.length);
        const service = this.services[rnd];
        try {
            const resp = await fetch(`${service}/health`, { method: "HEAD" });
            this.formantPing = resp.ok;
        } catch (ex: unknown) {
            this.formantPing = false;
        }
    };
}
